import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil';
import { URL } from '../../util/ambienteActions';
import { VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO } from '../types';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export function verificarItinerarioAtivoOuInativo(codigoItinerario) {
    const url = `${URL}/itinerario/${codigoItinerario}/verificar-itinerario-ativo-ou-inativo`;

    return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
        .then(response => dispatch({
            type: VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO,
            payload: response
        }))
        .catch(erro => {
            const offline = !navigator.onLine || !erro.response;
            return dispatch({ type: VERIFICAR_ITINERARIO_ATIVO_OU_INATIVO, payload: { data: offline, status: offline ? 200 : undefined } });
        });
}